import { getSVG } from './components/icons-loader.js';
import { Accordions } from './components/accordion.js';

document.addEventListener("DOMContentLoaded", async function () {
  const accordionButton = new Accordions('.legal-menu-button','.legal-submenu');
  accordionButton.enableButtons();
  accordionButton.legalMenuDefaultBehavior();
  accordionButton.defaultSubMenuBehavior();
  getSVG();
  accordionButton.defaultSubMenuBehavior();
});
